// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".team__image[data-v-b3d36c4a]{border-radius:50%}.team__title[data-v-b3d36c4a]{line-height:1.4;font-weight:600}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
